import React, { useContext } from "react";
import { Link as ScrollLink } from "react-scroll";
import { themeContext } from "../../../Context";
import { CLOUD_URL } from "../../../seo/seoConfig";
import "./ErpCta.css";

const ErpCta = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <section className="erp-cta" id="erp-cta">
      <h2 style={{ color: darkMode ? "white" : undefined }}>
        جاهز لتشغيل نظام ERP وبرنامج المحاسبة؟
      </h2>
      <p>
        ابدأ الاستخدام مجاناً عبر النظام السحابي، أو تواصل لعرض سعر حسب احتياج
        منشأتك — وحدات أساسية أو نظام متخصص لقطاعك.
      </p>
      <div className="erp-cta-actions">
        <a
          className="button erp-cta-btn"
          href={CLOUD_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          ابدأ الاستخدام مجاناً
        </a>
        <ScrollLink to="contact" spy={true} smooth={true} offset={-40}>
          <button type="button" className="button erp-cta-btn erp-cta-btn-secondary">
            اطلب عرض سعر
          </button>
        </ScrollLink>
      </div>
    </section>
  );
};

export default ErpCta;
